import type { IconNames } from '@dixa/lib-shared-habla';
import { v4 as uuid } from 'uuid';

import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { formatPortsHelper } from 'components/powerFlowShared/helpers/nodePortFormatter';
import {
  FlowNode,
  flowNodeColor,
  InternalPortT,
  NodeT,
  NodeTypeComponent,
  RegisterPortT,
} from 'fable/flowEditor';

import { PowerEmailFlowExtraDataT } from '../PowerEmailFlow';
import { ReplyModal as ActionModal } from '../modals/reply';

export type FlowEmailNodeReplyPayloadT = {
  auto_reply_template_id: string;
  next_node_id?: string;
};
export type FlowEmailNodeReplyTypeT = FlowNodeTypes.AUTOREPLY;
export type FlowEmailNodeReplyT = NodeT<
  FlowEmailNodeReplyTypeT,
  FlowEmailNodeReplyPayloadT
>;

const portTranslator = (node: FlowEmailNodeReplyT): RegisterPortT[] => {
  if (node.payload.next_node_id) {
    return [
      {
        id: uuid(),
        type: 'out',
        label: 'arrow',
        connection: node.payload.next_node_id,
      },
    ];
  }

  return [];
};

export class ReplyNode extends NodeTypeComponent<
  FlowEmailNodeReplyT,
  PowerEmailFlowExtraDataT
>() {
  static icon: IconNames = 'reply';
  static label = 'Auto-reply';
  static color = flowNodeColor.blue;
  static translatePayload = formatPortsHelper(portTranslator);
  static helpText = 'Send an automatic reply based on a custom template.';
  static ActionModal = ActionModal;
  static actionTrigger = { type: FlowNodeTypes.AUTOREPLY };
  static updateConnection = (
    node: FlowEmailNodeReplyT,
    _port: InternalPortT,
    newConnection: string,
  ): FlowEmailNodeReplyT => {
    const payload = { ...node.payload };
    payload.next_node_id = newConnection;

    return { ...node, payload };
  };

  triggerEdit = (): void => {
    const { onEdit, node } = this.props;
    onEdit(node, node.nodeType);
  };

  render() {
    const {
      node: {
        payload: { auto_reply_template_id },
      },
    } = this.props;

    return (
      <FlowNode
        color={ReplyNode.color}
        icon={ReplyNode.icon}
        label={ReplyNode.label}
        text={
          <span>
            Template <strong>{auto_reply_template_id}</strong>
          </span>
        }
        onEdit={this.triggerEdit}
      />
    );
  }
}
